import { Text } from '@chakra-ui/react';

function TitlePreview({ formValues: rawFormValues }: PreviewComponentProps) {
  const formValues = rawFormValues as ContentContainer;
  return (
    <Text fontSize={17} fontWeight={600} lineHeight="24px" w="100%">
      {formValues?.title || 'Tu pojawi się Twój tytuł'}
    </Text>
  );
}

export default TitlePreview;
